import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="author-autocomplete"
// A styled type-to-filter picker over the user's bookmarked authors. Selecting
// an option (or clearing) fills the hidden text field and submits the search form.
export default class extends Controller {
    static targets = ["input", "panel", "option", "clear"]

    connect() {
        this.activeIndex = -1
        this.toggleClear()
    }

    open() {
        this.filter()
        this.panelTarget.classList.remove("hidden")
    }

    close() {
        this.hideTimeout = setTimeout(() => this.panelTarget.classList.add("hidden"), 120)
    }

    filter() {
        const query = this.inputTarget.value.trim().toLowerCase()
        let visible = 0
        this.optionTargets.forEach((option) => {
            const match = option.dataset.value.toLowerCase().includes(query)
            option.classList.toggle("hidden", !match)
            option.classList.remove("bg-sky-50")
            if (match) visible++
        })
        this.activeIndex = -1
        this.panelTarget.classList.toggle("hidden", visible === 0)
        this.toggleClear()
    }

    select(e) {
        clearTimeout(this.hideTimeout)
        this.inputTarget.value = e.currentTarget.dataset.value
        this.panelTarget.classList.add("hidden")
        this.submit()
    }

    clear() {
        this.inputTarget.value = ""
        this.submit()
    }

    keydown(e) {
        const options = this.optionTargets.filter((o) => !o.classList.contains("hidden"))
        if (options.length === 0) return

        if (e.key === "ArrowDown" || e.key === "ArrowUp") {
            e.preventDefault()
            this.open()
            const step = e.key === "ArrowDown" ? 1 : -1
            this.activeIndex = (this.activeIndex + step + options.length) % options.length
            options.forEach((o, i) => o.classList.toggle("bg-sky-50", i === this.activeIndex))
            options[this.activeIndex].scrollIntoView({block: "nearest"})
        } else if (e.key === "Enter" && this.activeIndex >= 0) {
            e.preventDefault()
            this.inputTarget.value = options[this.activeIndex].dataset.value
            this.panelTarget.classList.add("hidden")
            this.submit()
        } else if (e.key === "Escape") {
            this.panelTarget.classList.add("hidden")
        }
    }

    submit() {
        this.toggleClear()
        this.element.closest("form").requestSubmit()
    }

    toggleClear() {
        if (this.hasClearTarget) this.clearTarget.classList.toggle("hidden", this.inputTarget.value === "")
    }
}
